import React, { memo } from 'react';

type AlertProps = { alert: string; }

const AlertBox: React.FC<AlertProps> = ({ alert }: AlertProps) => {
	return (
		<div className='uk-alert uk-alert-warning'>
			{/* <a className="uk-alert-close warning" data-uk-close></a> */}
			<p>{alert}</p>
		</div>
	)
}
export default memo(AlertBox)
